module.exports = __webpack_public_path__ + "img/geos.5e8d5823.png";